import React from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {AdminDashboardWrapper} from '../pages/AdminPages/dashboard/AdminDashboardWrapper'
import DedicatedNumberList from '../pages/AdminPages/DedicatedNumber/DedicatedNumberList'
import SharedNumberList from '../pages/AdminPages/SharedNumber/SharedNumberList'
import GatewayManagementList from '../pages/AdminPages/GatewayManagement/GatewayManagementList'
import GatewayConfigsList from '../pages/AdminPages/GatewayConfigs/GatewayConfigsList'
import AccountsPage_Admin from '../pages/AdminPages/MyProfile/AccountsPage_Admin'
import GlobalRateCardList from '../pages/AdminPages/Setup/GlobalRateCard/GlobalRateCardList'
import PaymentGatewayList from '../pages/AdminPages/Setup/PaymentGateway/PaymentGatewayList'
import AllCellCastUser from '../pages/AdminPages/AllCellCastUser/index'
import PurchaseCredits from '../pages/Common/PurchaseCredits'
import PageNotFound from './PageNotFound'
import StaffProfileDetails from '../pages/AdminPages/MyProfile/Staff_Account/StaffProfileDetail/StaffProfileDetails'
import UserProfileDetails from '../pages/AdminPages/AllCellCastUser/UserProfileDetail/UserProfileDetails'
import {SuspensedView} from '../Utils/AllHelperFunctions'
import WhiteLabelList from '../pages/AdminPages/WhiteLabel/WhiteLabelList'
import WhiteLabelProfileDetaile from '../pages/AdminPages/WhiteLabel/WhiteLabelProfile/WhiteLabelProfileDetaile'
import FirstMessageApprovalPage from '../pages/AdminPages/FirstMessageAprroval/FirstMessageApprovalPage'
import OptOutPopup from '../pages/UserPages/Opt_out/OptOutPopup'
import AdminOptOutLists from '../pages/AdminPages/Setup/Opt_out/OptOutLists'
import AdminOptOutPopup from '../pages/AdminPages/Setup/Opt_out/OptOutPopup'
import ReportPageWrapper from '../pages/UserPages/reports-analytics/ReportPageWrapper'
import GlobalSetting from '../pages/AdminPages/Setup/GlobalSetting/GlobalSetting'
import CampaignLog from '../pages/AdminPages/CampaignLog/CampaignLog'
import FraudKeywordPage from '../pages/AdminPages/Setup/FraudKeyword'
import MongoScale from '../pages/AdminPages/Setup/MongoScale'
import AssignedAccountApprovalPage from '../pages/AdminPages/AccountClasificationApproval/AccountClasificationApproval'
import UpdateSalesTypeApprovalPage from '../pages/AdminPages/AccountClasificationApproval/UpdateSalesTypeApprovalPage'
import NewPurchasePage from '../pages/AdminPages/Sales/NewPurchasePage'
import AllPurchasePage from '../pages/AdminPages/Sales/AllPurchasePage'
import CommissionPage from '../pages/AdminPages/Sales/CommissionPage'
import AdminActivityLogsPage from '../pages/AdminPages/ActivityLog/AdminActivityLog'
import SystemAlert from '../pages/AdminPages/Notification/SystemAlert/SystemAlert'
import UserSurvey from '../pages/AdminPages/Survey'
import AdminHowToVideosWrapper from '../pages/AdminPages/how-to-videos/AdminHowToVideosWrapper'
import MyTemplateListing from '../pages/UserPages/MyTemplate/MyTemplateListing'
import CreateScratchV2 from '../pages/UserPages/MyTemplate/CreateScratch/CreateScratchV2'
import TagsList from '../pages/AdminPages/Templates/Tags/TagsList'
import PromoActionList from '../pages/UserPages/promo-action/PromoActionList'
import FlowList from '../pages/UserPages/Flow/FlowList/FlowList'
import WorkFlow from '../pages/UserPages/Flow/WorkFlow/WorkFlow'
import { RoutePaths } from './RoutePath'
import CouponPage from '../pages/AdminPages/Sales/CouponPage'
import DashboardPerformance from '../pages/AdminPages/Sales/DashboardPerformance'
import PotentialChurn from '../pages/AdminPages/Sales/PotentialChurn'

const AdminRoutes = () => {
  return (
    <>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* <Route path='auth/*' element={<Navigate to='/dashboard' />} /> */}
          {/* <Route path="/notification" element={<NotificationConnect />} /> */}
          {localStorage.getItem('approval') !== '' && localStorage.getItem('approval') !== null ? (
            <Route
              path='auth/*'
              element={
                <Navigate
                  to={`/admin/message_approval/${localStorage
                    .getItem('approval')
                    ?.split('/')
                    .at(-2)}/${localStorage.getItem('approval')?.split('/').at(-1)}`}
                />
              }
            />
          ) : (
            <Route path='auth/*' element={<Navigate to='/dashboard' replace={true} />} />
          )}
          {/* <Route path='auth/*' element={<Navigate to={`/admin/message_approval/*`} />} /> */}
          <Route path='/admin/message_approval/*' element={<FirstMessageApprovalPage />} />
          <Route path='/admin/assigned-account-approval/:id' element={<AssignedAccountApprovalPage />} />
          <Route path='/admin/change-sales-type-approval/:id' element={<UpdateSalesTypeApprovalPage />} />
          <Route path='/admin/message_approval/*' element={<FirstMessageApprovalPage />} />
          <Route path='/dashboard' element={<AdminDashboardWrapper />} />
          <Route path='setting/global_ratecard' element={<GlobalRateCardList />} />
          <Route path='setting/global_setting' element={<GlobalSetting />} />
          <Route path='setting/payment_gateways' element={<PaymentGatewayList />} />
          <Route path='setting/opt_out' element={<AdminOptOutPopup />} />
          <Route path='setting/opt-out-list' element={<AdminOptOutLists />} />
          <Route path='setting/mongo_scale' element={<MongoScale />} />
          <Route path='setting/fraud_keyword' element={<FraudKeywordPage />} />

          <Route path={'eofy/*'} element={<ReportPageWrapper />} />

          <Route path='/gateway' element={<GatewayManagementList />} />
          <Route path='/config-gateways' element={<GatewayConfigsList />} />
          <Route path='/dedicated_Number' element={<DedicatedNumberList />} />
          <Route path='/shared-number' element={<SharedNumberList />} />
          <Route path='/topup' element={<PurchaseCredits />} />

          <Route path='/user-profile/*' element={<UserProfileDetails />} />
          <Route path='/staff-profile/*' element={<StaffProfileDetails />} />
          <Route path='/whiteLabel-profile/*' element={<WhiteLabelProfileDetaile />} />
          <Route path='/user-list' element={<AllCellCastUser />} />
          <Route path='/whitelabel-list' element={<WhiteLabelList />} />
          <Route path='/whitelabel-list' element={<WhiteLabelList />} />
          <Route path='/campaign-log' element={<CampaignLog />} />
          <Route path='/activity-log' element={<AdminActivityLogsPage />} />

          {/* sales */}
          <Route path='/sales/new-purchase' element={<NewPurchasePage />} />
          <Route path='/sales/all-purchase' element={<AllPurchasePage />} />
          <Route path='/sales/commissions' element={<CommissionPage />} />
          <Route path='/sales/coupons' element={<CouponPage />} />
          <Route path='/sales/performance' element={<DashboardPerformance />} />
          <Route path='/sales/potential-churn' element={<PotentialChurn />} />

          <Route path='/system-alert' element={<SystemAlert />} />
          <Route path='/user-survey' element={<UserSurvey />} />
          <Route path='/admin/how-to-videos' element={<AdminHowToVideosWrapper />} />
          
          <Route
            path='/templates/message-template'
            element={
              <SuspensedView>
                <MyTemplateListing />
              </SuspensedView>
            }
          />
          <Route
            path='/templates/base-tags'
            element={
              <SuspensedView>
                <TagsList />
              </SuspensedView>
            }
          />
          <Route
            path='/templates/promo-actions'
            element={
              <SuspensedView>
                <PromoActionList />
              </SuspensedView>
            }
          />

          <Route
            path='/templates/flows'
            element={
              <SuspensedView>
                <FlowList />
              </SuspensedView>
            }
          />
          <Route path={RoutePaths.templateAutomationNew} element={<WorkFlow />} />
          <Route path={RoutePaths.templateAutomationFlowDetail} element={<WorkFlow />} />
          
          <Route path={'/New-Template'} element={<CreateScratchV2 />} />

          <Route
            path={'/accounts/*'}
            element={
              <SuspensedView>
                <AccountsPage_Admin />
              </SuspensedView>
            }
          />
          {/* <Route path='*' element={<PageNotFound />} /> */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </>
  )
}

export default AdminRoutes
